import React ,{useState}from "react";
import css from "./notificationModal.module.scss";
import IconWave from "../../re_redesigned_componnents/icon/svg/wave.svg";
import { IconModalClose } from "Icons";
import { useHistory ,Redirect} from "react-router-dom/cjs/react-router-dom";
import * as config from "../../config";

function NotificationModel({ onClose = () => { console.log("no onClose prop passed") }, data }) {
  const history = useHistory();
  const [redirState, setredirState] = useState(false);
  const entityData = {
    ...(data.entity_details),
    course_list: data.course_list
  };

  const handleClose = () => {
    onClose(false);
    history.push(config.ROUTES.home); // Redirect to home after closing modal
  };
  let redirecting = redirState ? (
    <Redirect
      to={{ pathname: config.ROUTES.traineeCurriculum, entityEvalData: entityData, subjectData: entityData, assessmentData:1 ,data: entityData}}
    />
  ) : null;

  const handleCourseRedirect = () => {
    history.push({
      pathname: config.ROUTES.traineeCurriculum,
      state: {
        entityEvalData: entityData,
        subjectData: entityData,
        assessmentData: 1,
        data: entityData
      }
    });
  };

  return (
    <>{
      redirecting?redirecting :<div
      style={{
        background: `url(${IconWave})`,
      }}
      className={css.notiModalWrap}
    >
      <div className={css.bg}></div>
      <div className={css.header}>
        <p>Introduction to Java Programming</p>
        <IconModalClose onClick={handleClose} />
      </div>
      <div className={css.content}>
        <div className={css.startDate}>
          <p>Start Date</p>
          <p>{data.created_on}</p>
        </div>
        <div className={css.endDate}>
          <p>End Date</p>
          <p>Not specified</p>
        </div>
      </div>
      <div className={css.footer}>
        <p>{`Published by: ${data.created_by}`}</p>
        <button className={css.gotoBtn} onClick={()=>{
           setredirState(true)
        }
         
         }>
          Course
        </button>
      </div>
    </div>}</>
    
  );
}

export default NotificationModel;
